// src/components/SimpleComponents/SimpleUid.jsx
// *******************************************************************************
// IMPORTS
// *******************************************************************************
import SimpleInput from './SimpleInput';

// *******************************************************************************
// MAIN COMPONENT
// *******************************************************************************

/**
 * Free-form unique ID input for countries without a specific tax ID component.
 * Falls back gracefully for any country other than BR, PT, US.
 */
const SimpleUid = ({ ...props }) => {
  // 8. UI
  return <SimpleInput name="uid" label="unique_id" maxLength={50} {...props} />;
};

// *******************************************************************************
// EXPORT
// *******************************************************************************
export default SimpleUid;
